import {
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import {  App } from 'app/models';

@Component({
  standalone: false,
  selector: 'app-apps-photo',
  templateUrl: './apps-photo.component.html',
  styleUrls: ['./apps-photo.component.scss']
})
export class AppsPhotoComponent implements OnChanges {

  @Input() app: App;
  @Input() image: string;
  @Input() size = '48px';

  appInitials: string;

  ngOnChanges() {
    if (this.app) {
      this._parseName();
    }
  }

  private _parseName() {
    if (!this.app.name) {
      return;
    }
    this.appInitials = `${this.app.name[0].toUpperCase()}${this.app.name[this.app.name.length-1].toUpperCase()}`;
  }
}
